import { render, staticRenderFns } from "./pagehead.vue?vue&type=template&id=396c4946&"
import script from "./pagehead.vue?vue&type=script&lang=js&"
export * from "./pagehead.vue?vue&type=script&lang=js&"
import style0 from "./pagehead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports